/**
 * ImagePlaceholder — the design's own convention for a visual asset that does
 * not exist yet.
 *
 * ── WHY THIS IS A COMPONENT AND NOT A GAP ───────────────────────────────────
 *
 * Landing v2 draws missing imagery as a hatched panel with a monospace caption
 * naming what belongs there ("customer portrait — drop image here"). That is a
 * deliberate convention: it reserves the space, states the intent, and is
 * visibly not a finished surface, so nobody mistakes it for the design.
 *
 * The alternative — omitting the block — silently changes the layout the design
 * specifies, and the alternative to THAT is a stock photo, which is a claim
 * about a product nobody has photographed. A named hole beats both.
 *
 * ── NOT AN IMG ──────────────────────────────────────────────────────────────
 *
 * There is no src, so no image element and no alt. It is decorative scaffolding
 * and is hidden from assistive tech; the caption is for the person building the
 * page, not for a reader of it. When a real asset arrives this component is
 * REPLACED, not filled in.
 */
export function ImagePlaceholder({ caption, height = 200, radius = 'var(--radius-md)', className = '', style }) {
  return (
    <div
      className={`uxa-img-placeholder ${className}`.trim()}
      style={{ height, borderRadius: radius, ...style }}
      aria-hidden="true"
    >
      {caption ? <span className="uxa-img-placeholder__caption">{caption}</span> : null}
    </div>
  );
}

export default ImagePlaceholder;
